import React from 'react';
import { FileTextIcon, TrendingUpIcon, AlertCircleIcon, DownloadIcon } from 'lucide-react';
const FinancialReportsEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-1052">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1053">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-10 text-center" data-id="element-1054">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1055">
            <FileTextIcon size={32} className="text-blue-600" data-id="element-1056" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-1057">
            Tus reportes están listos
          </h1>
          <p className="text-blue-100" data-id="element-1058">Estados financieros de julio 2023</p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-1059">
          <div className="mb-8" data-id="element-1060">
            <p className="text-gray-700 text-lg mb-4" data-id="element-1061">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-1062">
              Tus estados financieros del mes de <strong data-id="element-1063">julio 2023</strong> ya
              están disponibles en tu dashboard de FinancePro.
            </p>
          </div>
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-1064">
            <div className="bg-blue-50 rounded-lg p-4 text-center" data-id="element-1065">
              <p className="text-sm text-gray-600 mb-1" data-id="element-1066">Ventas del mes</p>
              <p className="text-2xl font-bold text-blue-600" data-id="element-1067">$845,200</p>
              <p className="text-xs text-green-600 mt-1" data-id="element-1068">
                +18.5% vs mes anterior
              </p>
            </div>
            <div className="bg-green-50 rounded-lg p-4 text-center" data-id="element-1069">
              <p className="text-sm text-gray-600 mb-1" data-id="element-1070">Utilidad Neta</p>
              <p className="text-2xl font-bold text-green-600" data-id="element-1071">$124,680</p>
              <p className="text-xs text-gray-600 mt-1" data-id="element-1072">14.8% margen</p>
            </div>
            <div className="bg-purple-50 rounded-lg p-4 text-center" data-id="element-1073">
              <p className="text-sm text-gray-600 mb-1" data-id="element-1074">Cash disponible</p>
              <p className="text-2xl font-bold text-purple-600" data-id="element-1075">$245,300</p>
              <p className="text-xs text-red-600 mt-1" data-id="element-1076">
                -15.2% vs mes anterior
              </p>
            </div>
          </div>
          {/* Key Insights */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-5 mb-8" data-id="element-1077">
            <div className="flex items-start space-x-3" data-id="element-1078">
              <AlertCircleIcon size={24} className="text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1079" />
              <div data-id="element-1080">
                <h3 className="font-semibold text-gray-800 mb-2" data-id="element-1081">
                  Insights importantes
                </h3>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-1082">
                  <li className="flex items-start" data-id="element-1083">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-yellow-600 mr-2 mt-1.5 flex-shrink-0" data-id="element-1084"></span>
                    <span data-id="element-1085">
                      Tu flujo de caja es negativo por segundo mes consecutivo.
                      Revisa tus gastos e inversiones.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1086">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-yellow-600 mr-2 mt-1.5 flex-shrink-0" data-id="element-1087"></span>
                    <span data-id="element-1088">
                      Las cuentas por cobrar aumentaron 22.1%. Considera mejorar
                      tu estrategia de cobranza.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1089">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-yellow-600 mr-2 mt-1.5 flex-shrink-0" data-id="element-1090"></span>
                    <span data-id="element-1091">
                      El inventario está 45% por encima del promedio. Evalúa
                      estrategias para optimizarlo.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Available Reports */}
          <div className="mb-8" data-id="element-1092">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-1093">
              Reportes disponibles
            </h2>
            <div className="space-y-3" data-id="element-1094">
              <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-1095">
                <div className="flex items-center space-x-3" data-id="element-1096">
                  <FileTextIcon size={20} className="text-blue-600" data-id="element-1097" />
                  <div data-id="element-1098">
                    <p className="font-medium text-gray-800" data-id="element-1099">
                      Estado de Resultados
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1100">Julio 2023</p>
                  </div>
                </div>
                <button className="text-blue-600 hover:text-blue-700 flex items-center space-x-1 text-sm font-medium" data-id="element-1101">
                  <DownloadIcon size={16} data-id="element-1102" />
                  <span data-id="element-1103">Descargar</span>
                </button>
              </div>
              <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-1104">
                <div className="flex items-center space-x-3" data-id="element-1105">
                  <FileTextIcon size={20} className="text-blue-600" data-id="element-1106" />
                  <div data-id="element-1107">
                    <p className="font-medium text-gray-800" data-id="element-1108">
                      Flujo de Efectivo
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1109">Julio 2023</p>
                  </div>
                </div>
                <button className="text-blue-600 hover:text-blue-700 flex items-center space-x-1 text-sm font-medium" data-id="element-1110">
                  <DownloadIcon size={16} data-id="element-1111" />
                  <span data-id="element-1112">Descargar</span>
                </button>
              </div>
              <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-1113">
                <div className="flex items-center space-x-3" data-id="element-1114">
                  <FileTextIcon size={20} className="text-blue-600" data-id="element-1115" />
                  <div data-id="element-1116">
                    <p className="font-medium text-gray-800" data-id="element-1117">Balance General</p>
                    <p className="text-sm text-gray-500" data-id="element-1118">Julio 2023</p>
                  </div>
                </div>
                <button className="text-blue-600 hover:text-blue-700 flex items-center space-x-1 text-sm font-medium" data-id="element-1119">
                  <DownloadIcon size={16} data-id="element-1120" />
                  <span data-id="element-1121">Descargar</span>
                </button>
              </div>
            </div>
          </div>
          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-1122">
            <a href="/" className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-1123">
              Ver reportes completos
            </a>
          </div>
          {/* Support */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1124">
            <p className="text-gray-600 text-sm mb-2" data-id="element-1125">
              ¿Tienes preguntas sobre tus reportes?
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1126">
              Contáctanos en{' '}
              <a href="mailto:soporte@financepro.com" className="text-blue-600 hover:text-blue-700" data-id="element-1127">
                soporte@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1128">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1129">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1130">
            Recibiste este correo porque tienes una cuenta activa en FinancePro.
          </p>
        </div>
      </div>
    </div>;
};
export default FinancialReportsEmail;